import React from "react";
import VsPage from "./VsPage";

export default function VsFinviz() {
  return (
    <VsPage
      slug="finviz"
      competitor="Finviz Elite"
      competitorPrice="$39.50/mo"
      tagline="Finviz Elite is a professional screener. Moonbucks is a curated alert service. Finviz gives you every filter under the sun; Moonbucks gives you the four setups worth watching today."
      rows={[
        { label: "Universe screener with hundreds of filters",           them: true, us: "Curated by desk" },
        { label: "You choose which stocks matter",                       them: true, us: "We do" },
        { label: "Analyst-vetted BUY alerts delivered to you",           them: false, us: true },
        { label: "Plain-English explanation per alert",                  them: false, us: true },
        { label: "Public per-trade outcome audit",                       them: false, us: true },
        { label: "$10K portfolio simulation",                             them: false, us: true },
        { label: "Discord subscriber channel",                            them: false, us: true },
        { label: "Entry price",                                           them: "$39.50/mo", us: "$14.99/mo" },
      ]}
      whenThem={[
        "You already know how to screen and want the pro-grade filter set.",
        "You want a data terminal, not a curated feed.",
      ]}
      whenUs={[
        "You want someone else to do the screening AND the vetting.",
        "You want the plain-English 'here's what's firing today' shortlist.",
        "You want to see the audit trail before you subscribe.",
      ]}
    />
  );
}
